module.exports = __webpack_public_path__ + "static/media/11.78f52281.jpg";